import { PortOption } from './ace-trip-us-ports'

export const caPorts: PortOption[] = [
  { code: '0817', name: 'ABBOTSFORD-HUNTINGDON' },
  { code: '0318', name: 'ABERCORN' },
  { code: '0706', name: 'ADEN' },
  { code: '0841', name: 'ALDERGROVE' },
  { code: '0214', name: 'ANDOVER' },
  { code: '0329', name: 'ARMSTRONG' },
  { code: '0892', name: 'BEAVER CREEK' },
  { code: '0614', name: 'BIG BEAVER' },
  { code: '0507', name: 'BOISSEVAIN' },
  { code: '0815', name: 'BOUNDARY BAY' },
  { code: '0225', name: 'CAMPOBELLO' },
  { code: '0612', name: 'CARIEVALE' },
  { code: '0834', name: 'CARSON' },
  { code: '0521', name: 'CARTWRIGHT' },
  { code: '0707', name: 'CARWAY' },
  { code: '0816', name: 'CASCADE' },
  { code: '0215', name: 'CENTREVILLE' },
  { code: '0365', name: 'CHARTIERVILLE' },
  { code: '0709', name: 'CHIEF MOUNTAIN' },
  { code: '0836', name: 'CHOPAKA' },
  { code: '0216', name: 'CLAIR' },
  { code: '0337', name: 'CLARENCEVILLE' },
  { code: '0619', name: 'CLIMAX' },
  { code: '0409', name: 'CORNWALL' },
  { code: '0615', name: 'CORONACH' },
  { code: '0524', name: 'COULTER' },
  { code: '0705', name: 'COUTTS' },
  { code: '0311', name: 'COVEY HILL' },
  { code: '0520', name: 'CRYSTAL CITY' },
  { code: '0708', name: 'DEL BONITA' },
  { code: '0330', name: 'DUNDEE' },
  { code: '0362', name: 'EAST HEREFORD' },
  { code: '0369', name: 'EAST PINNACLE' },
  { code: '0213', name: 'EDMUNSTON' },
  { code: '0502', name: 'EMERSON' },
  { code: '0610', name: 'ESTEVAN HIGHWAY' },
  { code: '0410', name: 'FORT ERIE' },
  { code: '0478', name: 'FORT FRANCES BRIDGE' },
  { code: '0893', name: 'FRASER' },
  { code: '0332', name: 'FRELIGHSBURG' },
  { code: '0219', name: 'GILLESPIE PORTAGE' },
  { code: '0370', name: 'GLEN SUTTON' },
  { code: '0508', name: 'GOODLANDS' },
  { code: '0217', name: 'GRAND FALLS' },
  { code: '0503', name: 'GRETNA' },
  { code: '0333', name: 'HEMMINGFORD' },
  { code: '0302', name: 'HERDMAN' },
  { code: '0366', name: 'HEREFORD ROAD' },
  { code: '0334', name: 'HIGHWATER' },
  { code: '0818', name: 'KINGSGATE' },
  { code: '0420', name: 'KINGSTON' },
  { code: '0351', name: 'LACOLLE - ST BERNARD DE LACOLLE' },
  { code: '0456', name: 'LANSDOWNE - THOUSAND ISLANDS BRIDGE' },
  { code: '0522', name: 'LENA' },
  { code: '0895', name: 'LITTLE GOLD CREEK' },
  { code: '0523', name: 'LYLETON' },
  { code: '0835', name: 'MIDWAY' },
  { code: '0620', name: 'MONCHY' },
  { code: '0367', name: 'MORSES LINE' },
  { code: '0828', name: 'NELWAY' },
  { code: '0427', name: 'NIAGARA FALLS - QUEENSTON LEWISTON BRIDGE' },
  { code: '0613', name: 'NORTHGATE' },
  { code: '0602', name: 'NORTH PORTAL' },
  { code: '0368', name: 'NOYAN' },
  { code: '0819', name: 'OSOYOOS' },
  { code: '0616', name: 'OUNGRE' },
  { code: '0813', name: 'PACIFIC HIGHWAY' },
  { code: '0832', name: 'PATERSON' },
  { code: '0475', name: 'PIGEON RIVER' },
  { code: '0517', name: 'PINEY' },
  { code: '0891', name: 'PLEASANT CAMP' },
  { code: '0331', name: 'POHENEGAMOOK' },
  { code: '0439', name: 'PRESCOTT' },
  { code: '0488', name: 'RAINY RIVER' },
  { code: '0607', name: 'REGWAY' },
  { code: '0824', name: 'ROOSVILLE' },
  { code: '0324', name: 'ROUTE 221: LACOLLE' },
  { code: '0341', name: 'ROUTE 223: LACOLLE' },
  { code: '0822', name: 'RYKERTS' },
  { code: '0440', name: 'SARNIA' },
  { code: '0441', name: 'SAULT STE. MARIE' },
  { code: '0509', name: 'SNOWFLAKE' },
  { code: '0506', name: 'SOUTH JUNCTION' },
  { code: '0505', name: 'SPRAGUE' },
  { code: '0354', name: 'STANHOPE' },
  { code: '0314', name: 'STANSTEAD 55' },
  { code: '0376', name: 'STANSTEAD BEEBE' },
  { code: '0375', name: 'STANSTEAD RTE 143' },
  { code: '0328', name: 'ST ARMAND/PHILIPSBURG' },
  { code: '0205', name: 'ST. CROIX' },
  { code: '0339', name: 'Ste Aurelie' },
  { code: '0336', name: 'ST-JUST DE BRETENIERES' },
  { code: '0218', name: 'ST. LEONARD' },
  { code: '0335', name: 'ST PAMPHILE' },
  { code: '0231', name: 'ST. STEPHEN 3RD BRIDGE' },
  { code: '0516', name: 'TOLSTOI' },
  { code: '0617', name: 'TORQUAY' },
  { code: '0307', name: 'TROUT RIVER' },
  { code: '0811', name: 'VICTORIA' },
  { code: '0833', name: 'WANETA' },
  { code: '0618', name: 'WEST POPLAR RIVER' },
  { code: '0711', name: 'WILD HORSE' },
  { code: '0621', name: 'WILLOW CREEK' },
  { code: '0453', name: 'WINDSOR AMBASSADOR BRIDGE' },
  { code: '0455', name: 'WINDSOR GORDIE HOWE BRIDGE' },
  { code: '0452', name: 'WINDSOR TUNNEL' },
  { code: '0519', name: 'WINDYGATES' },
  { code: '0518', name: 'WINKLER' },
  { code: '0308', name: 'WOBURN' },
  { code: '0212', name: 'WOODSTOCK' },
  { code: '0025', name: 'YARMOUTH' },
]
